import { createFilledIcon } from "../createIcon";

export const AlertCircleFilledIcon = createFilledIcon(
  <>
    <path d="M12 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 1 0 0 19.2ZM10.8 12a1.2 1.2 0 1 0 2.4 0V7.2a1.2 1.2 0 0 0-2.4 0V12Zm0 4.2a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 0 0-2.4 0Z" />
  </>,
  "AlertCircleFilledIcon"
);
